<template>
  <div class="col-md-6">
    <div class="personal-card" @click="clickCheckIn">
      <div class="personal-card__people d-flex">
        <div class="personal-card__people-img">
          <img :src="memberAvatar" alt="" />
        </div>
        <div class="personal-card__people-contact">
          <h4 class="name">
            <!-- <p class="user-company">
                      美情健康股份有限...
                      <span class="icon-icn_company"></span>
                    </p> -->

            <p class="user-personal">
              {{ memberName }}
              <span :class="memberGenderClass"></span>
            </p>
          </h4>
          <p class="mobile">{{ memberPhone }}</p>
          <p v-if="card.member_type_name == '非會員'" class="member-id">
            非會員
          </p>
          <p v-else class="member-id">No.{{ memberNo }}</p>
        </div>
      </div>

      <div class="check-in-mode" :class="[checkInStatusColorClass]">
        {{ checkInStatus }}
      </div>

      <!-- 備註按鈕 -->
      <div class="note-button-area" v-if="!isNonMember">
        <button
          class="note-btn btn btn-sm btn-outline-info"
          @click.stop="showMemberNote"
          title="查看會員備註"
        >
          <i class="fa fa-sticky-note-o"></i>
          備註
        </button>
      </div>

      <div class="personal-card__program">{{ programName }}</div>

      <div class="personal-card__status d-flex">
        <div class="date">
          <div class="status-little-title">
            到期日
          </div>
          <div class="status-content">
            {{ programExpireAt }}
          </div>
        </div>

        <div class="times">
          <div class="status-little-title">
            可用次數
          </div>
          <div class="status-content">
            {{ avaliableCount }}
          </div>
        </div>

        <div class="times">
          <div class="status-little-title">
            贈送次數
          </div>
          <div class="status-content">
            {{ card.giveaway_number }}
          </div>
        </div>

        <div class="owe-money">
          <div class="status-little-title">
            欠費金額
          </div>
          <div class="status-content">
            <span class="owe-price">{{ unpaidAmount }}</span>
            <!-- //TODO: currency fomat -->
          </div>
        </div>
      </div>
    </div>
    <CompleteCheckIn :id="cardId" :courseCheckingLog="courseCheckingLog" />
    <UseFinished :id="cardId" />
    <HaveAttend :id="cardId" />
    <UnableCheckIn :id="cardId" />
    <RepeatCheckIn :id="cardId" />
    <NotToday :id="cardId" />
    <MemberCheckIn
      :id="cardId"
      @handleCheckIn="callCheckInApi"
      :memberName="memberName"
    />
    <!-- 會員備註Modal -->
    <MemberNote
      :id="cardId"
      :memberName="memberName"
      :memberDescription="memberDescription"
    />
  </div>
</template>

<script>
import moment from 'moment';
import CompleteCheckIn from '@/components/Modal/CompleteCheckIn';
import MemberCheckIn from '@/components/Modal/MemberCheckIn';
import UseFinished from '@/components/Modal/UseFinished';
import HaveAttend from '@/components/Modal/HaveAttend';
import UnableCheckIn from '@/components/Modal/UnableCheckIn';
import RepeatCheckIn from '@/components/Modal/RepeatCheckIn';
import NotToday from '@/components/Modal/NotToday';
import MemberNote from '@/components/Modal/MemberNote'; // 會員備註Modal
import { get } from 'lodash';
import { courseCheckIn, courseNonMemberCheckIn } from '@/api/course';

export default {
  props: {
    card: {
      required: true,
      type: Object
    },
    scheduleTime: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      courseCheckingLog: {}
    };
  },
  components: {
    CompleteCheckIn,
    MemberCheckIn,
    UseFinished,
    HaveAttend,
    NotToday,
    UnableCheckIn,
    RepeatCheckIn,
    MemberNote // 會員備註組件
  },
  computed: {
    cardId() {
      return get(this.card, 'id');
    },
    memberNo() {
      return get(this.card, 'no');
    },
    memberAvatar() {
      return get(this.card, 'member_avatar'); //'~@/assets/img/photos/派2.jpeg'
    },
    memberName() {
      return get(this.card, 'member_name');
    },
    memberGender() {
      return get(this.card, 'member_gender', 1);
    },
    memberGenderClass() {
      return this.memberGender === 1 ? 'icon-icn_man' : 'icon-icn_woman';
    },
    memberPhone() {
      return get(this.card, 'member_phone');
    },
    memberDescription() {
      return get(this.card, 'member_description', '');
    },
    memberType() {
      return get(this.card, 'member_type', 1);
    },
    unpaidAmount() {
      return get(this.card, 'order_unpaid_amount', 0);
    },
    avaliableCount() {
      return get(this.card, 'program_last_number', 0);
    },
    programName() {
      return get(this.card, 'program_name');
    },
    isCheckIn() {
      return get(this.card, 'check_in_type', 0);
    },
    checkInStatus() {
      const CHECKINTEXT = ['未報到', '已報到', '預約未到'];
      return CHECKINTEXT[this.isCheckIn];
    },
    checkInStatusColorClass() {
      const COLORCLASS = ['not-yet', 'already', 'not-check'];
      return COLORCLASS[this.isCheckIn];
    },
    courseEndTime() {
      return get(this.scheduleTime, 'end_at');
    },
    programExpireAt() {
      let expireAt = moment(get(this.card, 'program_end_at')).format(
        'YYYY-MM-DD'
      );

      return expireAt == 'Invalid date' ? '-' : expireAt;
    },
    courseId() {
      return get(this.scheduleTime, 'course.course_id');
    },
    checkinPost() {
      return {
        course_id: this.courseId,
        date: this.$route.params.date,
        schedule_time_id: this.scheduleTime.schedule_time_id,
        member_no: this.memberNo
      };
    },
    nonMemberCheckinPost() {
      return {
        course_id: this.courseId,
        date: this.$route.params.date,
        schedule_time_id: this.scheduleTime.schedule_time_id,
        member_name: this.memberName,
        member_phone: this.memberPhone
      };
    },
    checkIsToday() {
      let now = moment().format('YYYY-MM-DD');
      let date = this.$route.params.date;

      return now == date;
    },
    isNonMember() {
      return this.memberType == 5;
    }
  },
  methods: {
    callCheckInApi(cardId) {
      if (this.isNonMember) {
        courseNonMemberCheckIn(this.nonMemberCheckinPost, res => {
          this.courseCheckingLog = res;

          this.checkInCallback(cardId);
        });
      } else {
        courseCheckIn(this.checkinPost, res => {
          this.courseCheckingLog = res;

          this.checkInCallback(cardId);
        });
      }
    },
    clickCheckIn() {
      if (this.isCheckIn === 1) {
        //重複報到
        this.$bvModal.show(`repeat-checkin${this.card.id}`);
      } else if (this.unpaidAmount > 0) {
        //欠費未繳清 無法報到
        this.$bvModal.show(`unable-checkin${this.card.id}`);
      } else if (this.checkIsToday === false) {
        //確認是否為今日
        this.$bvModal.show(`not-today${this.card.id}`);
      } else {
        this.$bvModal.show(`member-checkin${this.card.id}`);
      }
    },
    checkInCallback(cardId) {
      this.$bvModal.hide(`member-checkin${cardId}`);

      this.$nextTick(() => {
        this.$emit('checkin');
        this.$bvModal.show(`complete-checkin-modal${cardId}`);
      });
    },
    // 顯示會員備註方法
    showMemberNote() {
      this.$bvModal.show(`member-note${this.card.id}`);
    }
  }
};
</script>

<style scoped>
.note-button-area {
  position: absolute;
  top: 20px;
  right: 260px;
  z-index: 10;
}

.note-btn {
  font-size: 18px;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.note-btn:hover {
  background-color: #17a2b8;
  color: white;
  transform: translateY(-1px);
  transition: all 0.2s ease;
}

.note-btn i {
  font-size: 14px;
}

.personal-card {
  position: relative;
}
</style>
